// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delete-button[data-v-3619e508] {\n  margin-left: 10px;\n}", "",{"version":3,"sources":["webpack://./resources/js/modules/client_levels/components/ClientLevelInput.vue"],"names":[],"mappings":"AACA;EACI,iBAAA;AAAJ","sourcesContent":["\n.delete-button {\n    margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
